module.exports = __webpack_public_path__ + "static/media/GR.b41b5f52.svg";